module.exports = __webpack_public_path__ + "static/image1@2x-f61d61c847fd93dc0292a3f550db1626.png";